import { UPLOAD_URL } from '../../../api/api';

// Uploaded newsletter assets are stored as absolute URLs built off UPLOAD_URL
// ("https://host/backend/uploads/newsletter-assets/x.jpg"). Rows saved before
// that was fixed are absolute AND wrong — built off API_URL, so they're
// missing the `/backend` prefix. Rebuild those from the `/uploads/` path so
// existing newsletters render without a database migration. Same pattern as
// mediaStore.js's mediaSrcToUrl.
const UPLOADS_MARKER = '/uploads/';

export function resolveAssetUrl(src) {
  if (!src || typeof src !== 'string') return src;
  const s = src.trim();
  if (!/^https?:\/\//i.test(s)) return s;
  if (s.startsWith(UPLOAD_URL)) return s;
  const i = s.indexOf(UPLOADS_MARKER);
  if (i !== -1) return `${UPLOAD_URL}${s.slice(i)}`;
  return s;
}
